import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/Seo";
import { Users, Award, MapPin, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <div className="container-bl py-10" data-testid="page-about">
      <Seo
        title="About B&L Rentals · Oxnard's 5-Star Vehicle Rental Host"
        description="Family-run peer-to-peer vehicle rental host serving Oxnard and Ventura County since 2021. 200+ trips, 5-star rating."
        canonical={typeof window !== "undefined" ? window.location.origin + "/about" : undefined}
      />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "About" }]} />
      <div className="max-w-3xl">
        <div className="text-sm uppercase tracking-widest text-[#E2AB20] font-semibold">About us</div>
        <h1 className="mt-2 text-4xl sm:text-5xl font-heading font-bold text-white">A dependable local host — not a rental counter.</h1>
        <p className="mt-5 text-lg text-[#AEB9C9] leading-relaxed">
          B&L Rentals started in 2021 with a single passenger van and a promise: treat every renter like a neighbor. Four years and 200+ trips later, we've kept a perfect 5-star rating by obsessing over the small stuff — spotless interiors, on-time pickups, honest communication, and a fleet that's actually reliable.
        </p>
        <p className="mt-4 text-[#AEB9C9] leading-relaxed">
          We're based in Oxnard and serve Ventura County from Port Hueneme up to Ojai. Whether you're shuttling a soccer team to Camarillo, driving to a Channel Islands ferry, or need an EV for the weekend, we've probably done a trip like yours before.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {[
          {icon: Award, k: "5.0", v: "Average trip rating"},
          {icon: Users, k: "200+", v: "Trips hosted"},
          {icon: MapPin, k: "25 mi", v: "Delivery radius"},
          {icon: ShieldCheck, k: "100%", v: "Insurance verified"},
        ].map((s, i) => (
          <div key={i} className="card-bl p-6">
            <s.icon size={20} className="text-[#E2AB20]" />
            <div className="mt-3 text-3xl font-heading font-bold text-white">{s.k}</div>
            <div className="text-sm text-[#AEB9C9]">{s.v}</div>
          </div>
        ))}
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-heading font-semibold text-white">Service area</h2>
          <ul className="mt-3 text-[#AEB9C9] space-y-1 text-sm">
            <li>· Oxnard, CA (home base)</li>
            <li>· Ventura & Downtown Ventura</li>
            <li>· Camarillo & Cal State Channel Islands</li>
            <li>· Port Hueneme</li>
            <li>· Ojai (delivery available)</li>
            <li>· Thousand Oaks (delivery available)</li>
          </ul>
        </div>
        <div>
          <h2 className="text-2xl font-heading font-semibold text-white">What we obsess over</h2>
          <ul className="mt-3 text-[#AEB9C9] space-y-2 text-sm">
            <li>· Every vehicle is detailed between rentals — no exceptions.</li>
            <li>· Full tank / full charge at pickup.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
